import { t } from "../../../services/utils";
import React from "react";
import { primaryDark60 } from "../../../constants/colors";
class WorkoutExerciseCountView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        height: WorkoutExerciseCountView.getHeight(this.props),
      },
      main: {
        fontSize: 16,
        color: primaryDark60,
        paddingTop: 5,
        paddingLeft: 10,
      },
    };
    let text;
    if (this.props.workout.length === 1) {
      text = t("completed_1Exercise");
    } else {
      let numExercises = this.props.workout.length;
      text = t("completedNumexercisesExercises", { numExercises });
    }
    return (
      <div style={styles.container}>
        <div style={styles.main}>{text}</div>
      </div>
    );
  };
  static getHeight(props) {
    return 32;
  }
}
export default WorkoutExerciseCountView;
